// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hotels_wrapper__1wRt5","top-hotels":"Hotels_top-hotels__3hx5i","form":"Hotels_form__3T__o"};